import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { TextField, Button, Grid, Typography, Container, MenuItem, Select, InputLabel, FormControl, Box, Snackbar, Alert, FormHelperText, RadioGroup, FormControlLabel, Radio, Link as MuiLink } from '@mui/material';
import { useParams } from 'react-router-dom';
import GenerateMeetingLinkButton from '../GoogleMeet/GenerateMeetingLinkButton';
import { format } from 'date-fns';
import GenerateZoomMeetingButton from '../Zoom/GenerateZoomMeetingButton';
import ZoomAuthButton from '../Zoom/ZoomAuthButton';
import GenerateMicrosoftTeamsLink from '../Microsoft/GenerateMicrosoftTeamsLink';
import GoogleMeetLogo from '../Post/GoogleMeetImage.png';
import ZoomMeetLogo from '../Post/ZoomMeetImage.png';
import TeamsMeetLogo from '../Post/TeamsMeetImage.png';
import { parseISO } from 'date-fns';
import Header1 from '../Header/Header1';
import Platform from '../Platform/Platform';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';
import Footer2 from '../Footer/Footer2';


const API_URL = process.env.REACT_APP_API_URL;

const styles = {
  glassBox: {
    backdropFilter: 'blur(15px)',
    backgroundColor: '#000000',
    borderRadius: '16px',
    padding: '2.5rem',
    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    width: '100%',
    maxWidth: '100%',
    textAlign: 'center',
  },
  logo: {
    width: '160px',
    height: '160px',
    margin: '0 auto 1rem',
  },
  text: {
    color: 'white',
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    width: '100%',
  },
  input: {
    marginBottom: '1rem',
    letterSpacing: 2,
    '& .MuiInputBase-input': {
      color: 'white',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)',
      transition: 'color 0.3s',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E90FF',
    },
    '&:hover .MuiInputLabel-root': {
      color: '#1E90FF',
    },
    '& .MuiSelect-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E90FF',
    },
  },
  dateInput: {
    marginBottom: '1rem',
    '& .MuiInputBase-input': {
      color: 'white',
    },
    '& .MuiInputBase-input::placeholder': {
      color: 'transparent',
      transition: 'color 0.3s',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)',
      transition: 'color 0.3s',
    },
    '& .Mui-focused .MuiInputBase-input::placeholder': {
      color: 'white',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E90FF',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E90FF',
    },
  },
  button: {
    backgroundColor: '#1E90FF',
    color: 'white',
    marginTop: '1.5rem',
  },

};

const CreateRequest1 = ({ onLogout }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const [startTime, setStartTime] = useState('');
  const [duration, setDuration] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [maxLimit, setMaxLimit] = useState('');
  const [price, setPrice] = useState(0);
  const [topicName, setTopicName] = useState('');
  const [description, setDescription] = useState('');
  const [sectionId, setSectionId] = useState('');
  const [subsectionId, setSubsectionId] = useState('');
  const [sections, setSections] = useState([]);
  const [subsections, setSubsections] = useState([]);
  const [error, setError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [language, setLanguage] = useState('');
  const [meetingLink, setMeetingLink] = useState("");
  const [googleMeetLink, setGoogleMeetLink] = useState('');
  const [languages, setLanguages] = useState([]);  // State for languages
  const [platform, setPlatform] = useState("");
  const [isValid, setIsValid] = useState(null);
  const [status, setStatus] = useState(null);
  const [id, setId] = useState(null);

  const { userId } = useParams();

  // to track the validity of the link
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const [goPriceless, setGoPriceless] = useState(false);


  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true); // to track check status

  const [userData, setUserData] = useState({
    name: '',
    surname: '',
    image: '',
    role: '',
  });

  useEffect(() => {
    const checkVerification = async () => {
      if (!userId) return;

      try {
        const response = await axios.post(`${API_URL}/api/check-verification/`, {
          user_id: userId,
        });

        setIsVerified(response.data.status === 'approved');
      } catch (error) {
        console.error('Verification check failed:', error);
        setIsVerified(false);
      } finally {
        setLoading(false);
      }
    };

    checkVerification();
  }, [userId]);



  const validateMeetingLink = (link, platform) => {
    const googleMeetRegex = /https:\/\/meet.google.com\/[a-zA-Z0-9\-]+/;

    const zoomRegex = /https:\/\/\w+\.zoom.us\/j\/\d+(\?pwd=[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]*)?/;  // Updated regex

    const teamsRegex = /https:\/\/teams\.live\.com\/meet\/[a-zA-Z0-9\-]+/;

    switch (platform) {
      case "googleMeet":
        return googleMeetRegex.test(link);
      case "zoom":
        return zoomRegex.test(link);
      case "microsoftTeams":
        return teamsRegex.test(link);
      default:
        return false;
    }
  };





  // Handle platform change
  const handlePlatformChange = (e) => {
    const selectedPlatform = e.target.value;
    setPlatform(selectedPlatform);

    // Validate the link immediately when platform is selected
    if (meetingLink && meetingLink.trim() !== "") {
      const isLinkValid = validateMeetingLink(meetingLink, selectedPlatform);
      setIsValid(isLinkValid);
      if (!isLinkValid) {
        setErrorMessage("Invalid link for the selected platform.");
      } else {
        setErrorMessage("");
      }
    } else {
      // Reset validation when link is empty
      setIsValid(true);
      setErrorMessage("");
    }
  };


  // Handle link change
  const handleLinkChange = (e) => {
    const link = e.target.value;
    setMeetingLink(link);

    // If the link is empty, reset validation and error message
    if (link.trim() === "") {
      setIsValid(true); // Set valid state as true when the link is empty
      setErrorMessage(""); // Reset the error message
    } else if (platform) {
      // Validate the link immediately when user types/pastes it
      const isLinkValid = validateMeetingLink(link, platform);
      setIsValid(isLinkValid);
      if (!isLinkValid) {
        setErrorMessage("Invalid link for the selected platform.");
      } else {
        setErrorMessage("");
      }
    }
  };



  useEffect(() => {
    axios.get(`${API_URL}/list_sections_and_subsections/?user_id=${userId}`)
      .then((response) => {
        const transformedSections = Object.entries(response.data.sections).map(([sectionName, sectionData]) => ({
          sectionId: sectionData.section_id,
          sectionName,
          subsections: sectionData.subsections,
        }));
        setSections(transformedSections);


        if (response.data.languages) {
          setLanguages(response.data.languages);
        }
      })
      .catch((error) => {
        console.error('Error fetching sections:', error);
      });
  }, [userId]);

  useEffect(() => {
    if (!userId) {
      return;
    }

    // Fetch user data
    axios.get(`${API_URL}/get_user_data/?user_id=${userId}`)
      .then((response) => {
        setUserData(response.data);
      })
      .catch((err) => console.error(err));
  }, [userId]);


  const showAlert = () => {
    const alertDiv = document.createElement('div');

    alertDiv.textContent = isVerified
      ? 'Session created successfully.'
      : 'Request session created successfully.';
    alertDiv.style.position = 'fixed';
    alertDiv.style.top = '100px';
    alertDiv.style.left = '50%';
    alertDiv.style.transform = 'translateX(-50%)';
    alertDiv.style.padding = '50px 100px';
    alertDiv.style.backgroundColor = '#1E90FF';
    alertDiv.style.color = 'black';
    alertDiv.style.borderRadius = '5px';
    alertDiv.style.zIndex = '9999';
    alertDiv.style.fontSize = '16px';

    document.body.appendChild(alertDiv);

    setTimeout(() => {
      alertDiv.remove();
    }, 20000);
  };





  const handleSectionChange = (event) => {
    const selectedSectionId = event.target.value;
    setSectionId(selectedSectionId);

    const selectedSection = sections.find(section => section.sectionId === selectedSectionId);
    setSubsections(selectedSection ? selectedSection.subsections : []);
    setSubsectionId('');
  };

  const handleSubsectionChange = (event) => {
    setSubsectionId(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handlePost = () => {
 
    const requiredFields = [
      { field: description, fieldName: "Description" },
      { field: language, fieldName: "Language" },
      { field: duration, fieldName: "Duration" },
      { field: price, fieldName: "Price" },
      { field: selectedDate, fieldName: "Select date" },
      { field: startTime, fieldName: "Start Time" },
      { field: platform, fieldName: "Platform" }
    ];

    if (isVerified) {
      requiredFields.push(
        { field: meetingLink, fieldName: "Meeting Link" },
      );
    }


    for (let { field, fieldName } of requiredFields) {
      if (field === undefined || field === null || field.toString().trim() === "") {
        if (fieldName === "Price" && field === 0) {
          continue; // Skip validation if price is 0
        }
        setError(`${fieldName} is required.`);
        setOpenSnackbar(true);
        return;
      }
    }


    // Validate startTime format (HH:mm) before passing to postData
    if (startTime && !/^\d{2}:\d{2}$/.test(startTime)) {
      setError('Start Time must be in the format HH:mm.');
      setOpenSnackbar(true);
      return;
    }


    // Parsing startTime and setting it with today's date context
    if (startTime) {
      // Combine startTime with today's date to create a full datetime
      const today = new Date();
      const timeParts = startTime.split(':');
      today.setHours(timeParts[0], timeParts[1]);

      // Now use the date-fns `format()` function to format the full datetime
      const formattedStartTime = format(today, "yyyy-MM-dd'T'HH:mm:ss");

      // Use parseISO to parse the formatted startTime into a valid Date object
      const parsedStartTime = parseISO(formattedStartTime);

      // Ensure that the parsed start time is valid
      if (isNaN(parsedStartTime)) {
        setError('Invalid start time.');
        setOpenSnackbar(true);
        return;
      }
    }



    // Validate the duration
    if (duration > 300) {
      setError('Duration cannot exceed 300 minutes.');
      setOpenSnackbar(true);
      return;
    }


    // Step 2: Find section and subsection names based on IDs
    const selectedSection = sections.find(section => section.sectionId === sectionId);
    const sectionName = selectedSection ? selectedSection.sectionName : '';

    const selectedSubsection = subsections.find(subsection => subsection.id === subsectionId);
    const subsectionName = selectedSubsection ? selectedSubsection.name : '';

    // Step 3: Prepare postData
    const postData = {
      user_id: userId,
      section_id: sectionId,
      section_name: sectionName,
      subsection_id: subsectionId,
      subsection_name: subsectionName,
      startTime: startTime,
      duration: duration,
      selectedDate: selectedDate,
      max_limit: maxLimit,
      price: price,
      topic_name: topicName,
      description: description,
      language: language,
      meeting_link: meetingLink,
      platform: platform
    };



    const endpoint = isVerified ? 'create_post' : 'create_request';
    const subscriptionError = isVerified
      ? 'You need an active subscription to post.'
      : 'You need an active subscription to request.';
    const generalError = isVerified
      ? 'An error occurred while posting. Please try again later.'
      : 'An error occurred while creating request. Please try again later.';

    axios.post(`${API_URL}/${endpoint}/`, postData)
      .then((response) => {
        setStatus('success');
        setId(response.data.id);
        
      })
      .catch((error) => {
        console.error('Error sending data:', error);
        if (error.response && error.response.status === 403) {
          setError(subscriptionError);
        } else {
          setError(generalError);
        }
        setOpenSnackbar(true);
      });
  };


  const handleChange = (event) => {
    setLanguage(event.target.value);
  };

  const handleRedirect = () => {
    navigate('/requesting-guidelines');  // Redirect to meeting guidelines page
  };


  const handleDurationChange = (e) => {
    setDuration(e.target.value);
  };

  const durationOptions = [];
  for (let i = 30; i <= 300; i += 30) {
    durationOptions.push(i);
  }

  const handleMaxLimitChange = (e) => {
    setMaxLimit(e.target.value);
  };

  const maxLimitOptions = [];
  for (let i = 10; i <= 100; i += 10) {
    maxLimitOptions.push(i);
  }

  const handlePriceChange = (e) => {
    setPrice(e.target.value);
  };

  // Generate price options based on intervals
  const priceOptions = [];

  // Interval of 10 from 0 to 100
  for (let i = 10; i <= 100; i += 10) {
    priceOptions.push(i);
  }

  // Interval of 25 from 100 to 300
  for (let i = 125; i <= 300; i += 25) {
    priceOptions.push(i);
  }

  // Interval of 50 from 300 to 500
  for (let i = 350; i <= 500; i += 50) {
    priceOptions.push(i);
  }

  const handleRadioChange = (event) => {
    const isGoPriceless = event.target.value === "goPriceless";
    setGoPriceless(isGoPriceless);
    if (isGoPriceless) {
      setPrice(0); // Set price to 0 if "Go priceless" is selected
    } else {
      setPrice(''); // Reset the price selection when going back to "Set Price"
    }
  };


  const renderPlatformInfo = () => {
    switch (platform) {
      case 'googleMeet':
        return (
          <Box textAlign="center">
            {/* <GoogleMeetIcon/> */}
            <img src={GoogleMeetLogo} alt="Google Meet" width={100} />
            <Typography variant="h6">Google Meet</Typography>
          </Box>
        );
      case 'zoom':
        return (
          <Box textAlign="center">
            <img src={ZoomMeetLogo} alt="Zoom" width={100} />
            <Typography variant="h6">Zoom</Typography>
          </Box>
        );
      case 'microsoftTeams':
        return (
          <Box textAlign="center">
            <img src={TeamsMeetLogo} alt="Microsoft Teams" width={100} />
            <Typography variant="h6">Microsoft Teams</Typography>
          </Box>
        );
      default:
        return <Typography variant="body1" sx={{ letterSpacing: 2 }}>No platform selected</Typography>;
    }
  };

  const [step, setStep] = useState(0);
  const totalSteps = 7;

  const handleNext = () => {
    if (step < totalSteps - 1) setStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if (step > 0) setStep((prev) => prev - 1);
  };


  return (
    <div style={{ backgroundColor: '#000000', minHeight: '100vh', color: '#ffffff', }}>
      <Box
        sx={{
          position: 'fixed', // or 'relative' / 'sticky' based on your layout
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1300, // higher than MUI drawers (default is 1200)
        }}
      >
        <Header1 userId={userId} onLogout={onLogout} />
      </Box>


      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box>
          <Platform userId={userId} onLogout={onLogout}/>
        </Box>
        <Box>
          <Container maxWidth="lg" sx={{
            marginBottom: { xs: '2rem', sm: '3rem', lg: '5rem' }, padding: '0 2rem', mt: {
              xs: 10,   // Mobile
              sm: 15,   // Small screens
              md: 20,   // Medium screens
              lg: 25,   // Large screens
              xl: 30,   // Extra-large screens
            }
          }}>
            <Box sx={{
              padding: '2rem',
              borderRadius: '8px',
              backgroundColor: '#000000',
              transition: 'border-color 0.3s ease',
              '&:hover': { borderColor: '#1E90FF' },
            }}>
              <Typography variant="h4" component="h1" sx={{
                marginTop: '1.5rem',
                textAlign: 'center',
                letterSpacing: 5,
                mb: 2,
                color: 'transparent',
                backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
              }}>
                Hi {userData.name},
              </Typography>

              {step === 0 && (

                <>

                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: 'center',
                      letterSpacing: 2,
                      mb: 10,
                      color: 'transparent',
                      backgroundImage: 'linear-gradient(45deg, white, white)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      fontStyle: 'italic', // This adds italics
                    }}
                  >
                    Tell us what would you like to {isVerified ? 'share in a real-time knowledge session.' : 'learn. We will connect you with an expert for a real-time knowledge session.'}
                  </Typography>


                  <Box
                    sx={{
                      width: {
                        xs: '100%',      // full width on extra small screens
                        sm: '100%',
                        md: '90%',       // 90% width on tablets
                        lg: '100%',       // 80% width on desktops
                        xl: '100%'        // 70% width on large screens
                      },
                      margin: '0 auto',  // center horizontally
                      paddingX: {
                        xs: 2,
                        sm: 3,
                        md: 4
                      }
                    }}
                  >
                    <TextField
                      label={isVerified ? "Share your expertise" : "Ask us anything..."}
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      value={description}
                      onChange={(e) =>
                        e.target.value.length <= 500 && setDescription(e.target.value)
                      }
                      helperText={`${description.length}/500 characters`}
                      inputProps={{
                        maxLength: 500,
                        style: { letterSpacing: 2, paddingTop: '24px' },
                      }}
                      InputLabelProps={{
                        style: { letterSpacing: 2 },
                        shrink: true,
                        sx: {
                          backgroundColor: 'black',
                          padding: '0 4px',
                          transform: 'translate(14px, -9px) scale(0.75)',
                        },
                      }}
                      FormHelperTextProps={{
                        style: {
                          letterSpacing: 2,
                          color: description.length > 450 ? 'orange' : 'inherit',
                        },
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '26px',
                          paddingTop: '8px',
                        },
                      }}
                    />
                  </Box>
                </>

              )}

              
              {step === 1 && (
                <>
                  <Box
                    sx={{
                      width: {
                        xs: '100%',
                        sm: '100%',
                        md: '80%',
                        lg: '70%',
                        xl: '60%',
                      },
                      mx: 'auto',
                      px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: 'center',
                        letterSpacing: 2,
                        mb: 5,
                        color: 'transparent',
                        backgroundImage: 'linear-gradient(45deg, white, white)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        fontStyle: 'italic',
                        fontSize: {
                          xs: '1rem',
                          sm: '1.2rem',
                          md: '1.4rem',
                        },
                      }}
                    >
                      Please select the language in which you will be communicating during the session.
                    </Typography>

                    <FormControl fullWidth sx={{ mb: 4 }}>
                      <InputLabel
                        id="language-select-label"
                        sx={{ letterSpacing: 2 }}
                      >
                        Language
                      </InputLabel>
                      <Select
                        labelId="language-select-label"
                        value={language}
                        onChange={handleChange}
                        label="Language"
                        sx={{
                          letterSpacing: 2,
                          color: 'white',
                          backgroundColor: '#5558',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#555555',
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#1E90FF',
                          },
                        }}
                      >
                        {languages.map((lang) => (
                          <MenuItem
                            key={lang.id}
                            value={lang.name}
                            sx={{ letterSpacing: 2 }}
                          >
                            {lang.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </>
              )}

             
              {step === 2 && (
                <>
                  <Box
                    sx={{
                      width: {
                        xs: '100%',     // 100% on extra-small devices
                        sm: '100%',
                        md: '80%',      // Reduced width on medium screens
                        lg: '70%',      // Further reduced on large screens
                        xl: '60%',      // Even more centered on extra-large
                      },
                      mx: 'auto',        // Center horizontally
                      px: {
                        xs: 2,           // Horizontal padding for mobile
                        sm: 3,
                        md: 4
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: 'center',
                        letterSpacing: 2,
                        mb: 5,
                        color: 'transparent',
                        backgroundImage: 'linear-gradient(45deg, white, white)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        fontStyle: 'italic',
                        fontSize: {
                          xs: '1rem',      // Responsive font size
                          sm: '1.2rem',
                          md: '1.4rem',
                        },
                      }}
                    >
                      Please select an available date for the session.
                    </Typography>

                    <TextField
                      label="Select Date"
                      type="date"
                      fullWidth
                      value={selectedDate}
                      onChange={handleDateChange}
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        input: { color: '#ffffff' },
                        letterSpacing: 2,
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: '#5558',
                          '& fieldset': { borderColor: '#555555' },
                        },
                        '& .MuiInputLabel-root': { color: '#aaaaaa' },
                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#1E90FF',
                        },
                      }}
                    />
                  </Box>
                </>


              )}

              {/* Step 7 */}
              {step === 3 && (
                <>
                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: {
                        xs: '100%',   // full width on mobile
                        sm: '90%',
                        md: '80%',
                        lg: '70%',
                        xl: '60%',
                      },
                      mx: 'auto',
                      px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: 'center',
                        letterSpacing: 2,
                        mb: {
                          xs: 6,
                          sm: 8,
                          md: 10,
                        },
                        color: 'transparent',
                        backgroundImage: 'linear-gradient(45deg, white, white)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        fontStyle: 'italic',
                        fontSize: {
                          xs: '1rem',
                          sm: '1.2rem',
                          md: '1.4rem',
                        },
                      }}
                    >
                      Please select an available time for the session.
                    </Typography>

                    <TextField
                      label="Start Time"
                      type="time"
                      fullWidth
                      value={startTime}
                      onChange={(e) => setStartTime(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        letterSpacing: 2,
                        fontSize: {
                          xs: '0.8rem',
                          sm: '0.9rem',
                          md: '1rem',
                        },
                        '& input': {
                          color: '#ffffff',
                          fontSize: {
                            xs: '0.9rem',
                            sm: '1rem',
                          },
                        },
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: '#5558',
                          borderRadius: '12px',
                          '& fieldset': { borderColor: '#555555' },
                        },
                        '& .MuiInputLabel-root': {
                          color: '#aaaaaa',
                          fontSize: {
                            xs: '0.9rem',
                            sm: '1rem',
                          },
                        },
                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#1E90FF',
                        },
                      }}
                    />
                  </Box>
                </>

              )}

              {step === 4 && (
                <>
                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: {
                        xs: '100%',   // full width on mobile
                        sm: '90%',
                        md: '80%',
                        lg: '70%',
                        xl: '60%',
                      },
                      mx: 'auto',
                      px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: 'center',
                        letterSpacing: 2,
                        mb: {
                          xs: 6,
                          sm: 8,
                          md: 10,
                        },
                        color: 'transparent',
                        backgroundImage: 'linear-gradient(45deg, white, white)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        fontStyle: 'italic',
                        fontSize: {
                          xs: '1rem',
                          sm: '1.2rem',
                          md: '1.4rem',
                        },
                      }}
                    >
                      Please select the duration of the session
                    </Typography>

                    <FormControl
                      fullWidth
                      variant="outlined"
                      required
                      sx={{
                        mb: 4,
                      }}
                    >
                      <InputLabel
                        id="duration-label"
                        sx={{
                          letterSpacing: 2,
                          fontSize: {
                            xs: '0.9rem',
                            sm: '1rem',
                          },
                        }}
                      >
                        Duration (in minutes)
                      </InputLabel>
                      <Select
                        labelId="duration-label"
                        value={duration}
                        onChange={handleDurationChange}
                        label="Duration (in minutes)"
                        sx={{
                          letterSpacing: 2,
                          fontSize: {
                            xs: '0.9rem',
                            sm: '1rem',
                          },
                          backgroundColor: '#5558',
                          color: '#ffffff',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#555555',
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#1E90FF',
                          },
                        }}
                      >
                        {durationOptions.map((option) => (
                          <MenuItem
                            key={option}
                            value={option}
                            sx={{ letterSpacing: 2 }}
                          >
                            {option} minutes
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText sx={{ letterSpacing: 2, fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                        (max 300 minutes)
                      </FormHelperText>
                    </FormControl>
                  </Box>
                </>
              )}

              {/* Step 8 */}
              {step === 5 && (
                <>
                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: {
                        xs: '100%',
                        sm: '90%',
                        md: '80%',
                        lg: '70%',
                        xl: '60%',
                      },
                      mx: 'auto',
                      px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: 'center',
                        letterSpacing: 2,
                        mb: {
                          xs: 6,
                          sm: 8,
                          md: 10,
                        },
                        color: 'transparent',
                        backgroundImage: 'linear-gradient(45deg, white, white)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        fontStyle: 'italic',
                        fontSize: {
                          xs: '1rem',
                          sm: '1.25rem',
                          md: '1.5rem',
                        },
                      }}
                    >
                      Please select a platform for the live session.
                    </Typography>

                    <FormControl
                      fullWidth
                      variant="outlined"
                      sx={{ mb: { xs: 3, sm: 4, md: 5 } }}
                    >
                      <InputLabel
                        id="platform-select-label"
                        sx={{
                          letterSpacing: 2,
                          fontSize: {
                            xs: '0.75rem',
                            sm: '0.875rem',
                            md: '1rem',
                          },
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        Select Platform for Live Session...
                      </InputLabel>
                      <Select
                        labelId="platform-select-label"
                        value={platform}
                        onChange={handlePlatformChange}
                        label="Select Platform for Live Session"
                        sx={{
                          letterSpacing: 2,
                          fontSize: {
                            xs: '0.75rem',
                            sm: '0.875rem',
                            md: '1rem',
                          },
                          backgroundColor: '#5558',
                          color: '#ffffff',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#555555',
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#1E90FF',
                          },
                        }}
                      >
                        <MenuItem value="googleMeet" sx={{ letterSpacing: 2 }}>
                          Google Meet
                        </MenuItem>
                        <MenuItem value="microsoftTeams" sx={{ letterSpacing: 2 }}>
                          Microsoft Teams
                        </MenuItem>
                        <MenuItem value="zoom" sx={{ letterSpacing: 2 }}>
                          Zoom
                        </MenuItem>
                      </Select>
                    </FormControl>

                    {renderPlatformInfo?.()}

                    {isVerified && (
                      <>
                        <TextField
                          label="Paste Session Link"
                          variant="outlined"
                          fullWidth
                          sx={{
                            letterSpacing: 2,
                            mt: {
                              xs: 2,
                              sm: 2,
                              md: 3,
                            },
                            input: { color: '#ffffff' },
                            '& .MuiOutlinedInput-root': {
                              backgroundColor: '#5558',
                              '& fieldset': { borderColor: '#555555' },
                            },
                            '& .MuiInputLabel-root': { color: '#aaaaaa' },
                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#1E90FF',
                            },
                          }}
                          value={meetingLink}
                          onChange={handleLinkChange}
                          error={isValid === false}
                          helperText={
                            isValid === false && meetingLink.trim() !== ""
                              ? errorMessage
                              : "Please go to the selected platform, generate the link for session, and paste it here."
                          }
                        />

                        {isValid === true && meetingLink.trim() !== "" && (
                          <Typography
                            sx={{
                              mt: 1,
                              color: "green",
                              fontSize: {
                                xs: '0.85rem',
                                sm: '1rem',
                              },
                              letterSpacing: 2,
                            }}
                          >
                            Link is valid!
                          </Typography>
                        )}

                        {isValid === false && meetingLink.trim() !== "" && (
                          <Typography
                            sx={{
                              mt: 1,
                              color: "red",
                              fontSize: {
                                xs: '0.85rem',
                                sm: '1rem',
                              },
                              letterSpacing: 2,
                            }}
                          >
                            Invalid link for the selected platform.
                          </Typography>
                        )}
                      </>
                    )}
                  </Box>
                </>

              )}


              {step === 6 && (
                <>
                  

                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: 'center',
                      letterSpacing: 2,
                      mb: 10,
                      color: 'transparent',
                      backgroundImage: 'linear-gradient(45deg, white, white)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      fontStyle: 'italic', // This adds italics
                    }}
                  >
                    Please select a price for the session.
                  </Typography>

                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: {
                        xs: '100%',
                        sm: '90%',
                        md: '80%',
                        lg: '70%',
                        xl: '60%',
                      },
                      mx: 'auto',
                      px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                      },
                    }}
                  >
                    <FormControl component="fieldset" >
                      <RadioGroup row value={goPriceless ? "goPriceless" : "setPrice"} onChange={handleRadioChange} sx={{ letterSpacing: 2 }}>
                        <FormControlLabel value="goPriceless" control={<Radio />} label="Go Priceless" sx={{ letterSpacing: 2 }} />
                        <FormControlLabel value="setPrice" control={<Radio />} label="Set Price" sx={{ letterSpacing: 2 }} />
                      </RadioGroup>
                    </FormControl>

                    {!goPriceless && (
                      <FormControl fullWidth variant="outlined" required sx={{ marginBottom: '1.5rem' }}>
                        <InputLabel id="price-label" sx={{ letterSpacing: 2 }}>Price in INR</InputLabel>
                        <Select
                          labelId="price-label"
                          value={price}
                          onChange={handlePriceChange}
                          label="Price in INR"
                          sx={{ letterSpacing: 2 }}
                        >
                          {priceOptions.map((option) => (
                            <MenuItem key={option} value={option} sx={{ letterSpacing: 2 }}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText sx={{ letterSpacing: 2 }}>
                          Please note: Price cannot exceed INR 500.
                        </FormHelperText>
                      </FormControl>
                    )}

                    {goPriceless && (
                      <FormHelperText sx={{ marginBottom: '1.5rem', letterSpacing: 2 }}>
                        Price is set to zero as you chose "Go Priceless".
                      </FormHelperText>
                    )}
                  </Box>
                </>
              )
              }

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: {
                    xs: 'column',
                    sm: 'row',
                  },
                  justifyContent: {
                    xs: 'center',
                    sm: 'space-between',
                  },
                  alignItems: 'center',
                  gap: 2,
                  mt: 4,
                  width: '100%',
                  maxWidth: {
                    xs: '100%',
                    sm: '80%',
                    md: '80%',  // Reduce width on medium screens
                    lg: '65%',
                  },
                  mx: 'auto', // Horizontally center the box
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleBack}
                  disabled={step === 0 || status === 'success'}
                  sx={{
                    width: { xs: '100%', sm: 'auto' },
                    letterSpacing: 2,
                    '&:disabled': {
                      borderColor: '#9e9e9e',
                      color: '#9e9e9e',
                    },
                  }}
                >
                  Back
                </Button>

                {step < totalSteps - 1 ? (
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{
                      width: { xs: '100%', sm: 'auto' },
                      letterSpacing: 2,
                    }}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={handlePost}
                    disabled={status === 'success'}
                    sx={{
                      width: { xs: '100%', sm: 'auto' },
                      backgroundColor: isVerified ? '#1976d2' : '#1E90FF',
                      color: '#fff',
                      letterSpacing: 2,
                      '&:disabled': {
                        backgroundColor: '#9e9e9e',
                        color: '#ffffff',
                      },
                    }}
                  >
                    Submit
                  </Button>
                )}
              </Box>

              {status === 'success' && (
                <Box
                  sx={{
                    textAlign: "center",
                    mt: 5,
                    px: 3,
                    py: 4,
                    borderRadius: "12px",
                    backgroundColor: "#001F3F",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 40, mb: 2 }} />

                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1E90FF",
                      letterSpacing: 2,
                      fontWeight: 700,
                      fontSize: {
                        xs: "1.1rem",
                        sm: "1.3rem",
                        md: "1.5rem",
                      },
                      lineHeight: 1.6,
                      mb: 1,
                    }}
                  >
                    Session created Successfully!
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: "#b0c4de",
                      letterSpacing: 1.5,
                      fontSize: {
                        xs: "0.9rem",
                        sm: "1rem",
                        md: "1.1rem",
                      },
                      maxWidth: "600px",
                      margin: "0 auto",
                    }}
                  >
                    Please visit{' '}
                    <MuiLink
                      component={Link}
                      to={
                        isVerified
                          ? `/my-post-tab-details/${id}/${userId}`
                          : `/my-request-tab-details/${id}/${userId}`
                      }
                      underline="hover"
                      sx={{ color: "#ffffff", fontWeight: "bold" }}
                    >
                      My sessions
                    </MuiLink>{' '}
                    to view your updates.
                  </Typography>

                  {/* Create New Button */}
                  <Button
                    variant="outlined"
                    onClick={() => window.location.reload()}
                    sx={{
                      mt: 3,
                      color: "#1E90FF",
                      borderColor: "#1E90FF",
                      letterSpacing: 2,
                      '&:hover': {
                        backgroundColor: "#1E90FF",
                        color: "#ffffff",
                      },
                    }}
                  >
                    Create New
                  </Button>
                </Box>
              )}

            </Box>

            <Snackbar
              open={openSnackbar}
              autoHideDuration={20000}
              onClose={() => setOpenSnackbar(false)}
            >
              <Alert severity="error" sx={{ width: '100%' }} onClose={() => setOpenSnackbar(false)}>
                {error}
              </Alert>
            </Snackbar>
          </Container>
        </Box>
      </Box>
      <Footer2 />
    </div>
  );
};

export default CreateRequest1;
